import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMarkdown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.25 9.99606V16C10.25 16.4142 10.5858 16.75 11 16.75C11.4142 16.75 11.75 16.4142 11.75 16V8.66534C11.75 7.74198 10.6055 7.31193 9.99742 8.00683L7.5 10.861L5.00258 8.00683C4.39454 7.31193 3.25 7.74197 3.25 8.66534V16C3.25 16.4142 3.58579 16.75 4 16.75C4.41421 16.75 4.75 16.4142 4.75 16V9.99606L6.74742 12.2788C7.14584 12.7342 7.85417 12.7342 8.25258 12.2788L10.25 9.99606Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18 7.74998C18.4142 7.74998 18.75 8.08576 18.75 8.49998V16C18.75 16.4142 18.4142 16.75 18 16.75C17.5858 16.75 17.25 16.4142 17.25 16V8.49998C17.25 8.08576 17.5858 7.74998 18 7.74998Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.4697 12.4696C14.7626 12.1768 15.2374 12.1768 15.5303 12.4696L18 14.9393L20.4697 12.4696C20.7626 12.1768 21.2374 12.1768 21.5303 12.4696C21.8232 12.7625 21.8232 13.2374 21.5303 13.5303L18.7071 16.3535C18.3166 16.7441 17.6834 16.7441 17.2929 16.3535L14.4697 13.5303C14.1768 13.2374 14.1768 12.7625 14.4697 12.4696Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconMarkdown as ReactComponent };
